import { fireCompoundAnalyticsEvent } from '@jira/polaris__lib-analytics/src/fireCompoundAnalyticsEvent.tsx';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

const getUpdatedState = (state: State, fieldKey: string, emoji: string | undefined) => ({
	...state,
	fields: {
		...state.fields,
		[fieldKey]: {
			...state.fields[fieldKey],
			emoji,
		},
	},
});

export const updateEmoji =
	(fieldKey: string, emoji: string | undefined, createAnalyticsEvent: CreateUIAnalyticsEvent) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ onFieldUpdateFailed, fieldRemote }: Props,
	): Promise<void> => {
		const state = getState();
		const field = state.fields[fieldKey];
		const oldEmoji = field.emoji;

		if (!field || field.emoji === emoji) {
			return;
		}

		setState(getUpdatedState(state, fieldKey, emoji));

		try {
			await fieldRemote.updateFieldConfiguration({
				fieldKey,
				oldConfiguration: oldEmoji ? { emoji: oldEmoji } : {},
				configuration: emoji ? { emoji } : {},
				type: 'updateEmoji',
			});

			fireCompoundAnalyticsEvent.FieldConfig.emojiChangedSuccess(createAnalyticsEvent({}), {
				issueFieldKey: fieldKey,
				issueFieldType: field.type,
			});
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (err: any) {
			setState(getUpdatedState(getState(), fieldKey, oldEmoji));
			fireCompoundAnalyticsEvent.FieldConfig.emojiChangedFailure(createAnalyticsEvent({}));
			onFieldUpdateFailed(err);
		}
	};
